<template>
  <section id="view-emr-order" v-loading="loading">
    <div class="tabs-content">
      <div class="container-default">
        <div class="case-creation">
          <div class="case-creation__step case-creation__patient-information">
            <div class="phlebio-status-navbar">
              <el-row type="flex" align="middle">
                <el-col :span="18">
                  <ul class="emr-result">
                    <li v-if="
                      this.getSinglePhlebioDetails &&
                      this.getSinglePhlebioDetails.accession_data &&
                      this.getSinglePhlebioDetails.accession_data.length
                    ">
                      <div>
                        <span class="name">Accession Id</span>
                        <span v-for="(
                            item, index
                          ) of getSinglePhlebioDetails.accession_data" :key="index" class="value cursor"
                          @click="goToCaseView(item.case_id)">{{ item.accession_id }}</span>
                      </div>
                    </li>
                    <li v-else-if="
                      this.getSinglePhlebioDetails &&
                      this.getSinglePhlebioDetails.accession_id
                    ">
                      <div>
                        <span class="name">Accession Id</span>
                        <span class="value cursor" @click="goToCaseView(getSinglePhlebioDetails.case_id)">{{
                          getSinglePhlebioDetails.accession_id }}</span>
                      </div>
                    </li>
                    <li>
                      <span class="name">Order Created On</span>
                      <span class="value">{{
                        momentWithTimezone(
                          this.getSinglePhlebioDetails.created_at,
                          "MM-DD-yyyy"
                        )
                      }}
                        {{
                          momentWithTimezone(
                            this.getSinglePhlebioDetails.created_at,
                            "hh:mm a"
                          )
                        }}
                      </span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6">
                  <ul class="emr-order-status">
                    <li v-if="
                      this.getSinglePhlebioDetails &&
                      this.getSinglePhlebioDetails.Status
                    ">
                      <span class="name">Order Status</span>

                      <span class="value">{{
                        this.getSinglePhlebioDetails.Status
                        }}</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
            <div class="case-creation__card">
              <div>
                <div class="vue-form">
                  <div class="case-creation__heading">
                    <div class="title-with-icon">
                      <span class="icon">
                        <img src="@/assets/images/icons/icon-patient-info.svg" alt="icon" class="img-fluid" />
                      </span>
                      <h3 class="title">Patient Information</h3>
                    </div>
                  </div>
                  <PatientInformation v-if="showDob" :patientInfo="patientInformation" ref="patientInformationForm">
                  </PatientInformation>
                  <el-form :model="caseInformationFormData">
                    <div class="case-creation__heading mt-15">
                      <div class="title-with-icon">
                        <span class="icon">
                          <img src="@/assets/images/icons/icon-case-info.svg" alt="icon" class="img-fluid" />
                        </span>
                        <h3 class="title">Case Information</h3>
                      </div>
                    </div>
                    <div class="case-creation__body mb-15">
                      <el-row :gutter="30">
                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Case Type
                                <span class="star">*</span>
                              </label>
                              <el-select v-model="caseInformationFormData.case_types" placeholder="Select Case Type"
                                multiple collapse-tags :multiple-limit="getCaseTypeLimit" filterable
                                @change="addSpecimenCaseTypes">
                                <el-option v-for="(caseType, index) of getCaseTypes" :key="index"
                                  :value="caseType.value" :label="caseType.case_name"
                                  :disabled="checkCaseTypeDisable(caseType)"></el-option>
                              </el-select>
                              <p class="err" v-if="
                                getCaseCreationValidationErrors &&
                                getCaseCreationValidationErrors.case_types
                              ">
                                {{ getCaseCreationValidationErrors.case_types }}
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Laboratory
                                <span class="star">*</span>
                              </label>
                              <el-select v-model="caseInformationFormData.lab" placeholder="Select Lab">
                                <el-option v-for="(lab, index) of getAllLabs" :key="index" :value="lab._id"
                                  :label="lab.name"></el-option>
                              </el-select>
                              <p class="err" v-if="
                                getCaseCreationValidationErrors &&
                                getCaseCreationValidationErrors.lab
                              ">
                                {{ getCaseCreationValidationErrors.lab }}
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>

                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Collection Date & Time
                                <span class="star">*</span>
                              </label>
                              <el-date-picker type="datetime" v-model="caseInformationFormData.collection_date
                                " placeholder="MM-DD-YYYY HH:MM AM" format="MM-DD-YYYY hh:mm A" @focus="checkDateValue"
                                :disabled-date="disabledDate" :default-time="defaultTime"></el-date-picker>
                              <p class="err">
                                <FormError errorName="collection_date"></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Received Date & Time
                                <span class="star">*</span>
                              </label>
                              <el-date-picker type="datetime" v-model="caseInformationFormData.received_date"
                                placeholder="MM-DD-YYYY HH:MM AM" format="MM-DD-YYYY hh:mm A" @focus="checkDateValue"
                                :disabled-date="disabledDate" :default-time="defaultTime"></el-date-picker>
                              <p class="err">
                                <FormError errorName="received_date"></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>

                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Ordering Facility
                                <span class="star">*</span>
                              </label>
                              <el-select v-model="caseInformationFormData.hospital"
                                placeholder="Select Ordering Facility" @change="fetchAllPhysiciansByHospital"
                                :filterable="true" clearable>
                                <el-option v-for="(
hospital, index
                                  ) of hospitalsData.data" :key="index" :value="hospital._id"
                                  :label="hospital.name"></el-option>
                              </el-select>
                              <p class="err">
                                <FormError errorName="hospital"></FormError>
                              </p>
                              <p class="err-visible" v-if="
                                this.getSinglePhlebioDetails &&
                                this.getSinglePhlebioDetails
                                  .mapping_failed_reason &&
                                this.getSinglePhlebioDetails
                                  .mapping_failed_reason.hospital
                              ">
                                {{
                                  this.getSinglePhlebioDetails
                                    .mapping_failed_reason.hospital
                                    ? this.getSinglePhlebioDetails
                                      .mapping_failed_reason.hospital
                                    : ""
                                }}
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">Ordering Facility Branch</label>
                              <el-select v-model="caseInformationFormData.hospital_branch
                                " placeholder="Select Ordering Facility Branch" :filterable="true"
                                @change="fetchAllPhysiciansByHospitalBranch" :clearable="true">
                                <el-option v-for="(hospital, index) of hopitalBranches" :key="index"
                                  :value="hospital._id" :label="hospital.display_name"></el-option>
                              </el-select>
                              <p class="err">
                                <FormError errorName="hospital_branch"></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Ordering Physician
                                <span class="star">*</span>
                              </label>
                              <el-select v-model="caseInformationFormData.ordering_physician
                                " placeholder="Select Ordering Physician" filterable>
                                <el-option v-for="(physician, index) of physicianOptions" :key="index"
                                  :label="physician.name" :value="physician._id"></el-option>
                              </el-select>
                              <p class="err">
                                <FormError errorName="ordering_physician"></FormError>
                              </p>
                              <p class="err-visible" v-if="
                                this.getSinglePhlebioDetails &&
                                this.getSinglePhlebioDetails
                                  .mapping_failed_reason &&
                                this.getSinglePhlebioDetails
                                  .mapping_failed_reason.physician
                              ">
                                {{
                                  this.getSinglePhlebioDetails
                                    .mapping_failed_reason.physician
                                    ? this.getSinglePhlebioDetails
                                      .mapping_failed_reason.physician
                                    : ""
                                }}
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>

                        <el-col :xl="12" :lg="20">
                          <div class="case-creation__input">
                            <el-form-item>
                              <div style="
                                  display: flex;
                                  align-items: center;
                                  column-gap: 2rem;
                                ">
                                <label for="text">ICD-10 ( Indicative )
                                  <span class="star">*</span>
                                </label>
                                <el-checkbox class="el-checkbox-icd" style="
                                    display: flex;
                                    align-items: center;
                                    height: 14px;
                                  " v-model="includeAllICDCodes">Include All ICD Codes</el-checkbox>
                              </div>

                              <div class="ten-icd-group d-flex">
                                <div class="each-input mr-5" v-for="(
icdCode, index
                                  ) of caseInformationFormData.icd_10_codesForm" :key="index">
                                  <el-autocomplete placeholder="CODE" v-model="icdCode.value"
                                    popper-class="ten-icd-popper" :fetch-suggestions="getAutoCompleteICDData"
                                    @select="selectICDCode($event, icdCode)">
                                    <template #default="{ item }">
                                      <div class="icd-dropdown-style">
                                        <span class="code pr-5">{{
                                          item.code
                                          }}</span>
                                        <span class="desc pl-5">{{
                                          item.description
                                          }}</span>
                                      </div>
                                    </template>
                                  </el-autocomplete>
                                </div>
                              </div>
                              <p class="err">
                                <FormError errorName="icd_10_codes"></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="case-creation__input">
                            <el-form-item>
                              <BillingTypesDropdown :billData="caseInformationFormData" :validataionErrors="getCaseCreationValidationErrors
                                " errorKey="billing_type"></BillingTypesDropdown>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="8" :lg="10" :md="3" :sm="6" :xs="6">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">Specimen Types
                                <span class="star">*</span></label>

                              <div class="specimen-case-type" v-for="(type, index) in this
                                .caseInformationFormData.sample_types" :key="index">
                                <span class="case-name">{{
                                  caseTypeMap[type.case_type]
                                  }}</span>
                                <span class="custom-select-capitalize">
                                  <el-select v-model="type.sample_types" multiple filterable allow-create
                                    :reserve-keyword="false" default-first-option popper-class="custom-select-dropdown">
                                    <el-option v-for="(
specimen, index
                                      ) in getSpecimenTypes[type.case_type]" :key="index" :label="specimen"
                                      :value="specimen"></el-option>
                                  </el-select>
                                  <p class="err">
                                    <FormError :errorName="`sample_types.${index}.sample_types`"></FormError>
                                  </p>
                                </span>
                              </div>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <!-- ! Test Information || Case Creation -->
                    <div class="case-creation__step case-creation__test-information">
                      <div class="case-creation__card">
                        <div class="case-creation__heading border-bottom-none">
                          <div class="title-with-icon">
                            <span class="icon">
                              <img src="@/assets/images/icons/icon-test-info.svg" alt="icon" class="img-fluid" />
                            </span>
                            <h3 class="title">Test Information</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="selected-tests-information" 
                    v-if="(panelsTestsData.selectedCategories &&
                      panelsTestsData.selectedCategories.length > 0 ) ||
                      (panelsTestsData.selectedGroup &&
                      panelsTestsData.selectedGroup.length > 0)"
                    >
                      <div class="each-test-information">
                        <el-checkbox-group class="case-vue-tabs vue-tabs">
                          <el-tabs>
                            <el-tab-pane v-for="(test, index) of getSelectedCaseTypes()" :key="index" :class="test">
                              <template #label>
                                <h3 class="selected-test-title">
                                  {{ caseTypeMap[test.case_type_code] }}
                                </h3>
                              </template>
                              <div v-if="test.case_type_code == 'TOXICOLOGY'">
                                <ToxicologyTestsPreview :panelTestsData="panelsTestsData" :newCase="checkCaseValidation"
                                  :test="test" :allSelectedTests="allTests"></ToxicologyTestsPreview>
                              </div>
                              <div v-else-if="test.case_type_code == 'WOUND'">
                                <WoundPanelSelectedTests :panelTestsData="panelsTestsData"
                                  :newCase="checkCaseValidation" :test="test" :allSelectedTests="allTests">
                                </WoundPanelSelectedTests>
                              </div>
                              <div v-else-if="test.case_type_code == 'UTI'">
                                <UTIPanelSelectedTests :panelTestsData="panelsTestsData" :newCase="checkCaseValidation"
                                  :test="test" :allSelectedTests="allTests"></UTIPanelSelectedTests>
                              </div>
                              <div v-else-if="test.case_type_code == 'NAIL'">
                                <NailPanelSelectedTests :panelTestsData="panelsTestsData" :newCase="checkCaseValidation"
                                  :test="test" :allSelectedTests="allTests"></NailPanelSelectedTests>
                              </div>
                              <div v-else-if="test.case_type_code == 'GASTRO'">
                                <GastroPanelSelectedTests :panelTestsData="panelsTestsData"
                                  :newCase="checkCaseValidation" :test="test" :allSelectedTests="allTests">
                                </GastroPanelSelectedTests>
                              </div>
                              <div v-else-if="
                                test.case_type_code == 'CLINICAL_CHEMISTRY'
                              ">
                                <BloodPanelSelectedTests :panelTestsData="panelsTestsData"
                                  :newCase="checkCaseValidation" :test="test" :allSelectedTests="allTests">
                                </BloodPanelSelectedTests>
                              </div>
                              <div v-else-if="
                                test.case_type_code == 'STI'
                              ">
                                <GTIWomensHealthTests :panelTestsData="panelsTestsData" :newCase="checkCaseValidation"
                                  :test="test" :allSelectedTests="allTests"></GTIWomensHealthTests>
                              </div>
                              <div v-else-if="test.case_type_code == 'URINALYSIS'">
                                <UrinalysisTestsPreview :panelTestsData="panelsTestsData" :newCase="checkCaseValidation"
                                  :test="test" :allSelectedTests="allTests"></UrinalysisTestsPreview>
                              </div>
                              <div v-else-if="
                                test.case_type_code ==
                                'RESPIRATORY_PATHOGEN_PANEL'
                              ">
                                <RespiratoryTestsPreview :panelTestsData="panelsTestsData"
                                  :newCase="checkCaseValidation" :test="test" :allSelectedTests="allTests">
                                </RespiratoryTestsPreview>
                              </div>
                              <div v-else>
                                <DefaultPanelSelectedTests v-if="show" :panelTestsData="panelsTestsData"
                                  :newCase="checkCaseValidation" :testType="test" :allSelectedTests="allTests"
                                  :caseType="test.case_type_code"></DefaultPanelSelectedTests>
                              </div>
                            </el-tab-pane>
                          </el-tabs>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="center-error-message" v-if="
                      this.getSinglePhlebioDetails &&
                      this.getSinglePhlebioDetails.mapping_failed_reason &&
                      this.getSinglePhlebioDetails.mapping_failed_reason.tests_info">
                      <p class="err-visible">
                        {{
                          this.getSinglePhlebioDetails.mapping_failed_reason.tests_info
                            ? this.getSinglePhlebioDetails.mapping_failed_reason.tests_info
                            : ""
                        }}
                      </p>
                    </div>
                    <span class="case-creation__divider"></span>
                    <!-- ! Billing Information || Case Creation -->
                    <div class="case-creation__step case-creation__billing-information"
                      v-if="caseInformationFormData.billing_type == 'INSURANCE'">
                      <div class="case-creation__heading justify-start">
                        <div class="title-with-icon">
                          <span class="icon">
                            <img src="@/assets/images/icons/icon-billing-info.svg" alt="icon" class="img-fluid" />
                          </span>
                          <h3 class="title">Billing Information</h3>
                        </div>
                        <div class="billing_alignmens">
                          <p class="err">
                            <FormError errorName="billing_info"></FormError>
                          </p>
                        </div>
                      </div>
                      <div class="case-creation__billing-information__body">
                        <div class="case-creation__tabs billing-information-tabs">
                          <el-tabs v-model="activeName" @tab-click="updateSelectedTabQuery">
                            <el-tab-pane name="first">
                              <template #label>
                                <span class="inactive-tabs" :class="{ 'active-tabs': hasError }">primary
                                  insurance</span>
                              </template>
                              <PrimaryInsurance v-if="activeName === 'first'" :primaryInsurance="primaryInsuranceForm"
                                :refreshDob="refreshPatientDob" :parentRefs="$refs" ref="primaryInsuranceForm">
                              </PrimaryInsurance>
                            </el-tab-pane>
                            <el-tab-pane name="second">
                              <template #label>
                                <span class="inactive-tabs" :class="{ 'active-tabs': hasSecondaryErrors }">Secondary
                                  Insurance</span>
                              </template>
                              <SecondaryInsurance v-if="activeName === 'second'"
                                :secondaryInsurance="secondaryInsuranceForm" ref="secondaryInsuranceForm"
                                :parentRefs="$refs" :refreshDob="true"></SecondaryInsurance>
                            </el-tab-pane>
                            <el-tab-pane name="third">
                              <template #label>
                                <span class="inactive-tabs" :class="{ 'active-tabs': hasTertiaryErrors }">Tertiary
                                  Insurance</span>
                              </template>

                              <TertiaryInsuranceForm v-if="activeName === 'third'"
                                :tertiaryInsurance="tertiaryInsuranceForm" ref="tertiaryInsuranceForm"
                                :parentRefs="$refs" :refreshDob="true"></TertiaryInsuranceForm>
                            </el-tab-pane>
                            <el-tab-pane name="fourth">
                              <template #label>
                                <span class="inactive-tabs"
                                  :class="{ 'active-tabs': hasGuarantorErrors }">Guarantor</span>
                              </template>

                              <GuarantorInsurance v-if="activeName === 'fourth'"
                                :guarantorInsurance="guarantorInsuranceForm" ref="guarantorInsuranceForm"
                                :parentRefs="$refs"></GuarantorInsurance>
                            </el-tab-pane>
                          </el-tabs>
                        </div>
                      </div>
                    </div>
                    <span class="case-creation__divider"></span>
                    <!-- Medications start here -->
                    <div class="case-creation__step case-creation__test-information">
                      <MedicationsAdd ref="medicationFormDetails"></MedicationsAdd>
                      <div class="center-error-message" v-if="isMedicationError">
                        <p class="err">
                          <FormError errorName="medication"></FormError>
                        </p>
                      </div>
                    </div>
                    <!-- Medications end here -->
                    <div class="center-error-message" v-if="isTestInfoError">
                      <p class="err">
                        <FormError errorName="tests_info"></FormError>
                      </p>
                    </div>
                    <div class="case-creation__actions">
                      <ul class="list">
                        <li>
                          <el-button type="button" class="btn cancel-button" @click="cancelPatientInformation">
                            Cancel
                          </el-button>
                        </li>
                        <li v-if="hasPermission('emr_orders', 'edit')">
                          <el-button type="button" class="btn save-button" @click="sumbmitPatientDetails"
                            :disabled="disablePatientInformation">
                            Update</el-button>
                        </li>
                        <li>
                          <el-button v-if="accessionCreated" type="button" class="btn save-button"
                            @click="checkCaseTypesToCreateAccession" :disabled="disablePatientInformation">
                            Create Accession</el-button>
                        </li>
                      </ul>
                    </div>
                  </el-form>
                </div>
              </div>
              <div class="default-modal">
                <el-dialog v-model="multipleAccession" width="30%" :before-close="handlePopupClose" v-loading="loading"
                  :close-on-click-modal="false">
                  <div class="dialog-header">
                    <span class="header-part">Select Casetype for Accession Creation</span>
                    <el-button size="medium" class="el-white" type="info" plain @click="handlePopupClose">
                      <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
                    </el-button>
                  </div>
                  <div class="popup-date pb-0">
                    <div class="popup-el-select">
                      <label>Case Type*:</label>
                      <el-select v-model="accessionCaseType" placeholder="Select Case Type"
                        @change="addAccessionSpecimenCaseTypes" multiple :multiple-limit="getCaseLimit">
                        <el-option v-for="(
                          caseType, index
                          ) of getSinglePhlebioDetails.case_types" :key="index" :value="caseType"
                          :label="caseTypeMap[caseType]" :disabled="checkCaseTypeAccesionDisable(caseType)"></el-option>
                      </el-select>
                    </div>
                    <div class="popup-el-select" v-if="accessionCaseType && accessionCaseType.length">
                      <label>Specimen Types*:</label>
                      <div class="specimen-case-type" 
                       v-for="(type, index) in caseInformationFormData.sample_types.filter(item => accessionCaseType.includes(item.case_type))"
                        :key="type.case_type">
                        <span class="case-name">{{
                          caseTypeMap[type.case_type]
                          }}</span>
                        <span class="custom-select-capitalize">
                          <el-select v-model="type.sample_types" multiple filterable allow-create
                            :reserve-keyword="false" default-first-option popper-class="custom-select-dropdown">
                            <el-option v-for="(specimen, index) in getSpecimenTypes[
                              type.case_type
                            ]" :key="index" :label="specimen" :value="specimen"></el-option>
                          </el-select>
                          <p class="err">
                            <FormError :errorName="`sample_types.${index}.sample_types`"></FormError>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div class="dialog-footer">
                      <el-button class="cancel-button" @click="handlePopupClose">Cancel</el-button>
                      <el-button :disabled="!accessionCaseType.length" class="blue-save-button"
                        @click="createAccessionNumber" :loading="loading">Create Accession</el-button>
                    </div>
                  </div>
                </el-dialog>
              </div>
              <ResonForChange v-if="takeReasonDialog" v-on:close="takeReasonDialog = false"
                v-on:reasonSubmit="updatePatient">
              </ResonForChange>
              <BillingValidation v-if="icdErrorDialog" :validationErrors="billingErrors"
                v-on:close="icdErrorDialog = false" :createOrder="true" @approveOrder="approveOrder">
              </BillingValidation>
              <ExistingCaseDetails v-if="errorDiloag" :convert="convertToCase" :existedCase="existedCaseDetails"
                :existedOrder="exisistingOrderData" v-on:closePopupDialog="handlePopUp" :caseType="accessionCaseType"
                @approveCase="approveCase" :validationErrorMsg="validationError">
              </ExistingCaseDetails>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";

import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import HospitalHelper from "@/mixins/HospitalHelper";

import caseConstants from "@/config/constants/caseConstants";
import PatientInformation from "@/components/phlebioOrders/PatientInformationAdd";
import FormError from "@/components/misc/FormError";

const BillingTypesDropdown = defineAsyncComponent(() =>
  import("@/components/misc/BillingTypesDropdown")
);
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import PrimaryInsurance from "@/components/phlebioOrders/billingInfo/forms/PrimaryInsurance";
import SecondaryInsurance from "@/components/phlebioOrders/billingInfo/forms/SecondaryInsurance";
import TertiaryInsuranceForm from "@/components/phlebioOrders/billingInfo/forms/TertiaryInsurance";
import GuarantorInsurance from "@/components/phlebioOrders/billingInfo/forms/GuarantorInsurance";

import MedicationsAdd from "@/components/phlebioOrders/MedicationsAdd";

const BillingValidation = defineAsyncComponent(() =>
  import("@/components/cases/BillingValidation")
);
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);

const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
export default {
  components: {
    BillingTypesDropdown,
    PatientInformation,
    FormError,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
    MedicationsAdd,
    ResonForChange,
    BillingValidation,
    ExistingCaseDetails,
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    BloodPanelSelectedTests,
    ToxicologyTestsPreview,
    DefaultPanelSelectedTests,
    NailPanelSelectedTests,
    GastroPanelSelectedTests,
    UrinalysisTestsPreview
  },
  mixins: [
    AppHelper,
    UserPermissionsHelper,
    HospitalHelper,
    caseDataHelper,
    InsuranceHelper,
  ],
  async created() {
    this.orderId = this.$route.params.phlebio_id;
    if (this.$route.params.phlebio_id) {
      await this.caseDetailsView();
    } else {
      this.loading = false;
    }

    this.showDob = true;

    this.getLabCaseTypes();
    this.caseInformationFormData.lab = this.getUserPrimaryLabId;
  },
  watch: {
    '$route.params.phlebio_id': {
      immediate: true,
      handler(newOrderId, oldOrderId) {
        if (newOrderId && newOrderId !== oldOrderId) {
          this.orderId = newOrderId;
          this.caseDetailsView();
        }
      }
    }
  },
  computed: {
    ...mapGetters("phlebio", [
      "getSinglePhlebioDetails",
      "getPhlebioTestInfo",
      "getCaseConversionStatus",
      "getValidationErrors",
      "getUpdatePhlebioStatus",
      "getSinglePhlebioTestsInfo"
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("branches", ["getAllBranches"]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    isTestInfoError() {
      if (this.getErrors && this.getErrors.tests_info) {
        return true;
      }
      return false;
    },
    isMedicationError() {
      if (this.getErrors && this.getErrors.medication) {
        return true;
      }
      return false;
    },

    accessionCreated() {
      const order = this.getSinglePhlebioDetails;

      if (!order) return false;

      // Check for valid statuses
      const validStatuses = [
        "Completed",
        "Performed",
        "Delivered to Lab",
        "Accession created",
        "Deliverd to Lab",
        "Partial Accession"
      ];

      // Check if status is valid
      const isStatusValid = validStatuses.includes(order.Status);

      // Check if accession_id exists
      const isAccessionCreated = !!order.accession_id;

      // Check if accession_data and case_types lengths are the same
      const isLengthsEqual =
        order.accession_data?.length === order.case_types?.length;

      return isStatusValid && !isAccessionCreated && !isLengthsEqual;
    },
    accessionDisableCreated() {
      const order = this.getSinglePhlebioDetails;
      if (order && order.accession_id) {
        return true;
      }
      if (
        order &&
        order.accession_data &&
        order.accession_data.length > 0 &&
        order.case_types &&
        order.case_types.length > 0 &&
        order.accession_data.length === order.case_types.length
      ) {
        return true;
      }
      if (order && order.accession_data && order.accession_data.length == 0) {
        return false;
      }
      if (order && order.case_types && order.case_types.length == 0) {
        return false;
      }
      return false;
    },

    getCaseTypeLimit() {
      if (
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length &&
        this.caseInformationFormData.case_types.indexOf("COVID_FLU") != -1
      ) {
        return 2;
      }
      if (
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length &&
        this.caseInformationFormData.case_types.indexOf("URINALYSIS") != -1
      ) {
        return 2;
      }

      return 3;
    },
    checkCaseTypeDisable() {
      return (caseType) => {
        if (
          this.caseInformationFormData.case_types &&
          this.caseInformationFormData.case_types.length &&
          this.caseInformationFormData.case_types.length == 2 &&
          this.caseInformationFormData.case_types.indexOf("COVID_FLU") == -1 &&
          caseType.value == "COVID_FLU"
        ) {
          return true;
        }
        if (
          this.caseInformationFormData.case_types &&
          this.caseInformationFormData.case_types.length &&
          this.caseInformationFormData.case_types.length == 2 &&
          this.caseInformationFormData.case_types.indexOf("URINALYSIS") == -1 &&
          caseType.value == "URINALYSIS"
        ) {
          return true;
        }
        return false;
      };
    },
    getCaseTypes() {
      return this.search_case_types;
    },
    getCaseLimit() {
      return 1;
    },
    CaseTypeDisable() {
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.accession_data &&
        this.getSinglePhlebioDetails.accession_data.length
      ) {
        return this.getSinglePhlebioDetails.accession_data.map(
          (obj) => obj.case_type
        );
      }
      return [];
    },
    ...mapGetters("errors", ["getErrors", "getError"]),
    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasSecondaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.secondary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasTertiaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.tertiary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasGuarantorErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf("billing_info.insurance.guarantor") !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasBillingType() {
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.billing_type &&
        this.getSinglePhlebioDetails.billing_type == "INSURANCE"
      ) {
        return true;
      }
      return false;
    },
  },

  data() {
    return {
      showDob: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      defaultTime: [new Date()],
      convertToCase: true,
      errorDiloag: false,
      existedCaseDetails: {},
      existingCaseData: {},
      disablePatientInformation: false,
      orderId: "",
      loading: false,
      takeReasonDialog: false,

      panels: [],
      getSpecimenTypes: { ...caseConstants.CASE_TYPE_SPECIMEN_TYPE_MAP },

      caseInformationFormData: {
        tests_info: [],
        case_types: [],
        collection_date: "",
        received_date: new Date(),
        lab: "",
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        specimen_collector: "",
        icd_10_codes: [],
        billing_type: "",
        sample_types: "",
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
      },
      hopitalBranches: [],
      allLabs: [],
      patientInfo: {},
      loadDateOfBirth: false,
      patientInformation: {},
      hospitalsData: {},
      physicianOptions: [],
      search_case_types: [],
      accessionCaseType: [],
      multipleAccession: false,
      specimenTypes: [],
      activeName: "first",
      refreshPatientDob: true,
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      includeAllICDCodes: false,
      icdErrorDialog: false,
      billingErrors: [],
      validationError: "",
      exisistingOrderData: {},
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: []
      },
      allTests: [],
      selectedTab: null,
    };
  },

  methods: {
    async fetchSinglePhleioTest() {
      try {
        let params = {
          phlebioOrderId: this.$route.params.phlebio_id,
          lab: this.caseInformationFormData.lab,
          case_type: (this.accessionCaseType.length
            ? this.accessionCaseType
            : this.caseInformationFormData.case_types
          ).join(',')
        }
        await this.$store.dispatch("phlebio/fetchSinglePhlebioTestsInfo", params)
      } catch (err) {
        console.log('err: ', err);
      }
    },
    getSelectedCaseTypes() {
      if (
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length
      ) {
        let data = [...this.panelsTestsData.selectedCategories, ...this.panelsTestsData.selectedGroup]

        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    updateSelectedTabQuery() {
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },
    checkCaseTypeAccesionDisable(value) {
      return this.CaseTypeDisable.includes(value);
    },
    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },
    changetocaptila(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
    addAccessionSpecimenCaseTypes() {
      if (!this.caseInformationFormData.sample_types) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types.length == 0
      ) {
        this.caseInformationFormData.sample_types = [];
      }
      if (this.accessionCaseType && this.accessionCaseType.length) {
        this.accessionCaseType.forEach((singleCaseType) => {
          let caseSampleTypeExisted =
            this.caseInformationFormData.sample_types.find(
              (e) => e.case_type == singleCaseType
            );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformationFormData.sample_types.push(
              caseTypeDefaultSampleName
            );
          }
        });
        // we need to remove not existed
        this.caseInformationFormData.sample_types =
          this.caseInformationFormData.sample_types.filter((sampleTypeData) =>
            this.caseInformationFormData.case_types.includes(
              sampleTypeData.case_type
            )
          );
      } else {
        this.caseInformationFormData.sample_types = [];
      }
    },
    addSpecimenCaseTypes() {
      if (!this.caseInformationFormData.sample_types) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length == 0
      ) {
        this.caseInformationFormData.sample_types = [];
      }
      if (
        this.caseInformationFormData &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length
      ) {
        this.caseInformationFormData.case_types.forEach((singleCaseType) => {
          let caseSampleTypeExisted =
            this.caseInformationFormData.sample_types.find(
              (e) => e.case_type == singleCaseType
            );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [],
            };
            this.caseInformationFormData.sample_types.push(
              caseTypeDefaultSampleName
            );
          }
        });

        this.caseInformationFormData.sample_types =
          this.caseInformationFormData.sample_types.filter((sampleTypeData) =>
            this.caseInformationFormData.case_types.includes(
              sampleTypeData.case_type
            )
          );
      } else {
        this.caseInformationFormData.sample_types = [];
      }
    },

    async caseDetailsView() {
      await this.checkCaseInformation();
    },
    async fetchPhlebioTestsInfo() {
      this.loading = true;
      let params = {
        phlebio_order_id: this.orderId,
        case_type: this.accessionCaseType.length
          ? this.accessionCaseType
          : this.caseInformationFormData.case_types,
      };
      await this.$store.dispatch(
        "phlebio/fetchSinglePhlebioOrderTestsInfo",
        params
      );
      this.loading = false;
    },

    async fetchAllPhysiciansByHospital(hospital) {
      this.caseInformationFormData.ordering_physician = undefined;
      this.caseInformationFormData.hospital_branch = null;
      let params = {
        hospital,
        get_all: true,
      };
      if (hospital) {
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        if (this.getAllPhysicians.data && this.getAllPhysicians.data.length) {
          this.physicianOptions = this.getAllPhysicians.data;
        }

        await this.$store.dispatch("branches/fetchAllBranches", {
          hospital_id: hospital,
          get_all: true,
        });
        this.hopitalBranches = this.getAllBranches.data;
      }
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      this.caseInformationFormData.ordering_physician = undefined;

      if (hospitalBranch) {
        let params = {
          hospital_branch: hospitalBranch,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      } else {
        this.fetchAllPhysiciansByHospital(
          this.caseInformationFormData.hospital
        );
      }
    },

    checkDateValue() {
      this.$nextTick(() => {
        let pickerBodies = document.getElementsByClassName(
          "el-date-picker__editor-wrap"
        );
        for (let pickerBody of pickerBodies) {
          let inputs = pickerBody.getElementsByClassName("el-input__inner");
          for (let input of inputs) {
            input.setAttribute("readonly", "");
          }
        }
      });
    },
    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_string = searchString.trim();
        }
        if (
          this.caseInformationFormData.case_types &&
          this.caseInformationFormData.case_types.length &&
          this.includeAllICDCodes == false
        ) {
          params.primary_case_types =
            this.caseInformationFormData.case_types[0];
        }
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = JSON.parse(JSON.stringify(this.getAllIcd10Codes));

        if (
          allIcdCodes &&
          allIcdCodes.data &&
          this.search_code === searchString
        ) {
          return cb(
            allIcdCodes.data.map((el) => {
              return {
                value: el.code,
                description: el.description,
              };
            })
          );
        } else {
          return cb([]);
        }
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.value;
      this.previousSearchString = "";
    },
    specimenPreparation() {
      if (
        this.getSinglePhlebioDetails &&
        this.caseInformationFormData.sample_types &&
        this.caseInformationFormData.case_types &&
        this.caseInformationFormData.case_types.length > 1
      ) {
        const selectedSpecimen =
          this.caseInformationFormData.sample_types.filter(
            (caseObj) => caseObj.case_type === this.accessionCaseType[0]
          );
        this.specimenTypes = selectedSpecimen;
      }
    },
    prepareEmrUpdateDetails() {
      let patientFormInfo = this.$refs["patientInformationForm"];
      return {
        case_types: this.accessionCaseType.length
          ? this.accessionCaseType
          : this.caseInformationFormData.case_types,
        collection_date: this.convertToLabUTC(
          this.caseInformationFormData.collection_date
        ),
        received_date: this.convertToLabUTC(
          this.caseInformationFormData.received_date
        ),
        hospital: this.caseInformationFormData.hospital,
        icd_10_codes: this.caseInformationFormData.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformationFormData.ordering_physician,
        hospital_branch: this.caseInformationFormData.hospital_branch
          ? this.caseInformationFormData.hospital_branch
          : null,
        billing_type: this.caseInformationFormData.billing_type,
        patient_info: patientFormInfo.formatPatientInfo(),
        sample_types: this.specimenTypes.length
          ? this.convertSampleTypesToCapital(this.specimenTypes)
          : this.convertSampleTypesToCapital(
            this.caseInformationFormData.sample_types
          ),
      };
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };

      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });

      return params;
    },

    async cancelPatientInformation() {
      await this.$store.commit("errors/clear", null, { root: true });
      await this.$store.commit("phlebio/setValidationErrors", null, {
        root: true,
      });

      this.$router.push({
        name: "PhlebioOrderDetails",
        query: { ...this.$route.query },
      });
    },
    async updatePatient(reason) {
      let params = this.prepareEmrUpdateDetails();
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformationFormData.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      }
      if (params.patient_info.email) {
        params.patient_info.email = params.patient_info.email.toLowerCase();
      }
      if (this.getPhlebioTestInfo && this.getPhlebioTestInfo.data) {
        params.tests_info = this.getPhlebioTestInfo.data;
      }
      let medicationFormDetails = this.$refs["medicationFormDetails"];
      if (medicationFormDetails) {
        params.medication = medicationFormDetails.getMedicationsList();
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.attachments
      ) {
        params.attachments = this.getSinglePhlebioDetails.attachments;
      }
      params.reason = reason;
      params.phlebio_id = this.orderId;
      // delete params.sample_types;
      params.coriell_test_panels = this.panelsTestsData.selectedCoriellPanels;
      if (params.case_types?.some(type =>
        ["UTI", "WOUND", "NAIL", "GASTRO", "RESPIRATORY_PATHOGEN_PANEL", "URINALYSIS","STI"].includes(type))
      ) {
        params.groups = [...this.getSinglePhlebioTestsInfo.groups]
      } else {
        let panels = [...this.getSinglePhlebioTestsInfo.panels]
        params.panels = panels.map((e) => {
          return {
            "panel_id": e.panel_id,
            "test_ids": e.specific_test_ids,
            "emr_order_code": e.emr_order_code,
            "lab_order_code": e.lab_order_code,
            "case_type_code": e.case_type_code
          }
        });
      }
      this.loading = true;
      await this.$store.dispatch("phlebio/updatePhlebio", params);
      if (this.getUpdatePhlebioStatus) {
        successNotification("Order updated successfully");
        this.cancelPatientInformation();
      } else {
        errorNotification("Error while updating order");
      }
      this.loading = false;
    },

    async sumbmitPatientDetails() {
      if (this.orderId) {
        this.askReason();
      }
    },

    handlePopupClose() {
      this.multipleAccession = false;
      this.accessionCaseType = [];
      this.caseInformationFormData.sample_type = "";
    },
    checkCaseTypesToCreateAccession() {
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.case_types &&
        this.getSinglePhlebioDetails.case_types.length > 1
      ) {
        this.multipleAccession = true;
      } else {
        this.createAccessionNumber();
      }
    },
    async createAccessionNumber() {
      try {
        if (this.patientInformation) {
          this.$refs["patientInformationForm"];
        }
        this.specimenPreparation();
        await this.fetchPhlebioTestsInfo();
        await this.fetchSinglePhleioTest()
        if (this.getPhlebioTestInfo) {
          this.multipleAccession = false;
          await this.accessionCreation();
        } else {
          errorNotification("Unable to Fetch Test Information");
        }
      } catch (error) {
        console.log(error);
        // this.multipleAccession = true;
      }
    },

    convertSampleTypesToCapital(sampleTypes) {
      if (!sampleTypes) return "";
      return sampleTypes.map((s) => {
        s.sample_types = s.sample_types.map((f) => this.changetocaptila(f));
        return s;
      });
    },
    creatingAccessionDetails() {
      let params = this.prepareEmrUpdateDetails();
      if (params.patient_info.email) {
        params.patient_info.email = params.patient_info.email.toLowerCase();
      }

      params.lab = this.caseInformationFormData.lab;
      params.phlebio_order_id = this.orderId;

      params.specimen_collector =
        this.caseInformationFormData.specimen_collector;
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.attachments
      ) {
        params.attachments = this.getSinglePhlebioDetails.attachments;
      }
      if (this.getPhlebioTestInfo && this.getPhlebioTestInfo.data) {
        params.tests_info = this.getPhlebioTestInfo.data;
      }
      params.coriell_test_panels = this.panelsTestsData.selectedCoriellPanels;
      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformationFormData.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      }
      let medicationFormDetails = this.$refs["medicationFormDetails"];
      if (medicationFormDetails) {
        params.medication = medicationFormDetails.getMedicationsList();
      }
      if (
        this.getSinglePhlebioDetails &&
        Array.isArray(this.getSinglePhlebioDetails.toxicology_ereq_form) &&
        this.getSinglePhlebioDetails.toxicology_ereq_form.length > 0
      ) {
        params.toxicology_ereq_form = this.getSinglePhlebioDetails.toxicology_ereq_form || []
      }
      params.Order_Type = this.getSinglePhlebioDetails.Order_Type || ""
      params.Priority = this.getSinglePhlebioDetails.Priority || ""
      if (params.case_types?.some(type =>
        ["UTI", "WOUND", "NAIL", "GASTRO", "RESPIRATORY_PATHOGEN_PANEL", "URINALYSIS", "STI"].includes(type))
      ) {
        params.groups = [...this.getSinglePhlebioTestsInfo.groups]
      } else {
        let panels = [...this.getSinglePhlebioTestsInfo.panels]
        params.panels = panels.map((e) => {
          return {
            "panel_id": e.panel_id,
            "test_ids": e.specific_test_ids,
            "emr_order_code": e.emr_order_code,
            "lab_order_code": e.lab_order_code
          }
        });
      }

      return params;
    },
    handleAccessionResponse() {
      if (this.getCaseConversionStatus) {
        this.accessionCaseType = [];
        this.caseInformationFormData.sample_type = "";
        successNotification("Convert To Case Successfully");
        this.$router.push({
          name: "AllPhlebioRequests",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      } else if (
        this.getValidationErrors &&
        this.getValidationErrors.error_code &&
        (this.getValidationErrors.error_code === "GENETIC_TEST_EXISTED" ||
          this.getValidationErrors.error_code === "TEST_ALREADY_EXISTED" ||
          this.getValidationErrors.error_code === "NON_GENTIC_TEST_VALIDATE" ||
          this.getValidationErrors.error_code == "DUPLICATE_EXISTED")
      ) {
        this.errorDiloag = true;
        this.validationError = this.getValidationErrors.error_code;
        if (
          this.getValidationErrors.errors &&
          this.getValidationErrors.errors.existed_details
        )
          this.existedCaseDetails =
            this.getValidationErrors.errors.existed_details;
        this.exisistingOrderData = this.creatingAccessionDetails();
      } else if (
        this.getValidationErrors &&
        this.getValidationErrors.error_code &&
        this.getValidationErrors.error_code === "BILLING_VALIDATION_ERRORS"
      ) {
        this.icdErrorDialog = true;
        this.billingErrors = this.getValidationErrors.errors;
      } else if (
        this.getValidationErrors.error_code == "PENDING_CASE_EXISTED"
      ) {
        this.multipleAccession = false;
      } else if (
        this.getValidationErrors.errors &&
        this.getValidationErrors.errors.details &&
        this.getValidationErrors.errors.details.length &&
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.case_types &&
        this.getSinglePhlebioDetails.case_types.length > 1
      ) {
        const desiredKey = "sample_types"; // The key you want to check for

        const keyExists = this.getValidationErrors.errors.details.find(
          (obj) => obj.key === desiredKey
        );
        if (keyExists) {
          this.multipleAccession = true;
        } else {
          this.multipleAccession = false;
        }
      } else {
        if (!this.getErrors || this.getError) {
          errorNotification(
            this.getError.message || "Error While creating acession"
          );
          this.accessionCaseType = [];
          this.caseInformationFormData.sample_type = "";
        }
      }
    },
    async accessionCreation() {
      try {
        this.loading = true;
        let params = this.creatingAccessionDetails();
        await this.$store.dispatch("phlebio/convertToCase", params);
        this.handleAccessionResponse();
        this.loading = false;
      } catch (error) {
        console.log(error);
        // this.multipleAccession = true;
      }
    },
    async approveOrder(response) {
      await this.$store.commit("errors/clear");
      this.loading = true;
      this.icdErrorDialog = response;
      let params = this.creatingAccessionDetails();
      params.billing_acknowledged = true;
      await this.$store.dispatch("phlebio/convertToCase", params);
      this.handleAccessionResponse();

      this.loading = false;
    },
    async approveCase(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      this.loading = true;
      let params = this.creatingAccessionDetails();
      params.auto_approved = true;
      params.billing_acknowledged = true;
      await this.$store.dispatch("phlebio/convertToCase", params);
      if (this.getCaseConversionStatus) {
        this.accessionCaseType = [];
        this.caseInformationFormData.sample_type = "";
        successNotification("Convert To Case Successfully");
        this.$router.push({
          name: "AllPhlebioRequests",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      } else {
        if (!this.getErrors || this.getError) {
          errorNotification("Error While creating acession");
          this.accessionCaseType = [];
          this.caseInformationFormData.sample_type = "";
        }
      }
      this.loading = false;
    },
    async askReason() {
      this.takeReasonDialog = true;
    },

    async checkCaseInformation() {
      this.loading = true;

      let params = {
        phlebio_id: this.orderId
      };
      await this.$store.dispatch("phlebio/phlebioDetails", params);
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.patient_info
      ) {
        this.patientInformation = this.getSinglePhlebioDetails.patient_info;
      }
      this.setCaseInformationData();
      this.loading = false;
    },
    async setCaseInformationData() {
      this.loading = true;
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.case_types
      ) {
        this.caseInformationFormData.case_types =
          this.getSinglePhlebioDetails.case_types;
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.case_types &&
        this.getSinglePhlebioDetails.case_types.length == 1
      ) {
        this.accessionCaseType = this.getSinglePhlebioDetails.case_types;
        this.addSpecimenCaseTypes();
      }

      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.collection_date
      ) {
        this.caseInformationFormData.collection_date =
          this.convertLabUTCToClient(
            this.getSinglePhlebioDetails.collection_date
          );
      }

      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.received_date
      ) {
        this.caseInformationFormData.received_date = this.convertLabUTCToClient(
          this.getSinglePhlebioDetails.received_date
        );
      }

      this.caseInformationFormData.hospital =
        this.getSinglePhlebioDetails && this.getSinglePhlebioDetails.hospital
          ? this.getSinglePhlebioDetails.hospital._id
          : null;
      this.fetchAllPhysiciansByHospital();
      if (this.caseInformationFormData.hospital) {
        this.fetchAllPhysiciansByHospitalBranch();
      }
      this.caseInformationFormData.hospital_branch =
        this.getSinglePhlebioDetails &&
          this.getSinglePhlebioDetails.hospital_branch
          ? this.getSinglePhlebioDetails.hospital_branch._id
          : null;
      this.caseInformationFormData.ordering_physician =
        this.getSinglePhlebioDetails &&
          this.getSinglePhlebioDetails.ordering_physician
          ? this.getSinglePhlebioDetails.ordering_physician._id
          : null;
      this.caseInformationFormData.icd_10_codes =
        this.getSinglePhlebioDetails &&
          this.getSinglePhlebioDetails.icd_10_codes
          ? this.getSinglePhlebioDetails.icd_10_codes
          : [];
      this.caseInformationFormData.billing_type =
        this.getSinglePhlebioDetails &&
          this.getSinglePhlebioDetails.billing_type
          ? this.getSinglePhlebioDetails.billing_type
          : "";
      if (
        this.caseInformationFormData.icd_10_codes &&
        Array.isArray(this.caseInformationFormData.icd_10_codes) &&
        Array.isArray(this.caseInformationFormData.icd_10_codesForm)
      ) {
        this.caseInformationFormData.icd_10_codes.forEach((el, index) => {
          if (this.caseInformationFormData.icd_10_codesForm[index]) {
            this.caseInformationFormData.icd_10_codesForm[index].value = el;
          }
        });
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.sample_types
      ) {
        this.caseInformationFormData.sample_types =
          this.getSinglePhlebioDetails.sample_types;
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance &&
        this.getSinglePhlebioDetails.billing_info.insurance.primary_insurance
      ) {
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getSinglePhlebioDetails.billing_info.insurance.primary_insurance
        );
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance &&
        this.getSinglePhlebioDetails.billing_info.insurance.secondary_insurance
      ) {
        this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getSinglePhlebioDetails.billing_info.insurance
            .secondary_insurance
        );
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance &&
        this.getSinglePhlebioDetails.billing_info.insurance.tertiary_insurance
      ) {
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getSinglePhlebioDetails.billing_info.insurance.tertiary_insurance
        );
      }
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance &&
        this.getSinglePhlebioDetails.billing_info.insurance.guarantor
      ) {
        this.guarantorInsuranceForm =
          this.getSinglePhlebioDetails.billing_info.insurance.guarantor;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      await this.$store.dispatch("labs/fetchAllLabs", { get_all: true });
      await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
        get_all: true,
      });
      await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
        get_all: true,
      });
      if (this.getSinglePhlebioDetails) {
        let testPanelsGroups = [...this.getSinglePhlebioDetails.panels,...this.getSinglePhlebioDetails.groups] || []
        this.panelsTestsData.selectedTestIds = this.getSinglePhlebioDetails.panels.flatMap(el => el.specific_test_ids) || [];

        let orderPanelsTestsInfo = testPanelsGroups.filter((test) => !test.group_id)
        let orderGroupsTestsInfo = testPanelsGroups.filter((test) => test.group_id)

        const transformed = orderPanelsTestsInfo.map((e) => {
          return {
            "panel_id": e.panel_id,
            "test_ids": e.specific_test_ids,
            "lab_order_code": e.lab_order_code,
            "case_type_code": e.case_type_code
          }
        });
        this.panelsTestsData.selectedCategories = transformed

        const uniqueGroups = Object.values(
          orderGroupsTestsInfo.reduce((acc, test) => {
            if (!acc[test.group_id]) {
              acc[test.group_id] = {
                group_id: test.group_id,
                group_code: test.group_code,
                group_title: test.group_title,
                case_type_code: test.case_type_code,
              };
            }
            return acc;
          }, {})
        );

        this.panelsTestsData.selectedGroup = uniqueGroups.map((e) => {
          e._id = e.group_id;
          let panelIds = testPanelsGroups
            .filter((test) => test.group_id === e.group_id)
            .flatMap((test) => test.panel_ids); // flatten any array structure
          e.panel_ids = Array.from(new Set(panelIds)); // dedupe
          e.case_type_code = e.case_type_code;
          return e;
        });

        this.allTests = testPanelsGroups
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
#view-emr-order {
  padding: 0;

  .phlebio-status-navbar {
    border-top: 1.2px solid #e7e7f7;
    border-bottom: 1.2px solid #e7e7f7;
    font-size: 14px;
    background: #ffffff;
    border-radius: 7px;
    padding: 3px 10px;
    margin-bottom: 10px;

    @mixin button-style {
      padding: 0 10px;
      font-size: 14px;
      border-radius: 4px;
      font-weight: 500;
      height: 25px;
      min-height: auto;
      text-transform: uppercase;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .name {
      color: rgba(37, 33, 59, 0.8);
      text-transform: capitalize;
      margin-right: 10px;
      font-weight: 500;
    }

    .value {
      border: 0.6px solid #5162fd;
      color: #5162fd;
      margin-right: 10px;
      @include button-style();
      margin-right: 7px;
      font-size: 12.5px;

      &.COMPLETED {
        background: #f2f2f2;
        border: 0.6px solid #4bb543;
        color: #4bb543;
      }

      &.CANCELLED {
        background: #f2f2f2;
        border: 0.6px solid #eb5757;
        color: #eb5757;
      }
    }

    .emr-result {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      li {
        margin: 5px 0;

        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }

    .emr-order-status {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;

      li {
        margin: 5px 0;

        &:not(:last-child) {
          margin-right: 10px;
        }

        button {
          @include button-style();
        }

        .text-danger {
          @include button-style();
          background-color: #fe7968;
          border: none;
        }
      }
    }
  }

  .tabs-content {
    .case-creation__card {
      background: transparent;
      position: relative;
    }

    .case-creation__heading,
    .case-creation__body {
      background: #fff;
    }

    .title-block {
      display: none;
    }

    .steps-data-view {
      background: #fff;
      padding: 20px;

      .title-with-icon {
        margin-bottom: 5px;

        .title {
          font-size: 1.1em;
          color: #0a5da6;
        }
      }
    }
  }

  .case-creation__body {
    position: relative;
  }

  .case-creation__billing-information__body {
    background: #fff;
  }

  .edit-btn {
    position: absolute;
    right: 10px;
    border: none;
    z-index: 99;
    right: 15px;
    padding: 0;
    top: -3px;

    background-color: transparent;
    color: #828282;

    .edit-icon {
      img {
        position: relative;
        top: 2.5px;
      }
    }
  }

  .err-visible {
    margin-top: 3px !important;
    color: #eb5757;
    font-size: 12px;
    min-height: 20px;
    margin-bottom: 5px;
    line-height: 20px;
    font-weight: 500;
    padding-left: 2px;
  }
}
</style>
